export default __webpack_public_path__ + "/dist/images/image2.750fffe993aeb2bdf2ca540556054b87.jpg";